import React from 'react'
import "../../Styles/LiveIcon.css"

export default function LiveIcon() {
  return (
    <div className="live-icon-wrapper">
        <span className="live-dot"></span>
        <p className="live-text">LIVE</p>
    </div>
  )
}
